import { attr, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const SchoolType = ApplicationRecord.extend({
  static: {
    jsonapiType: 'school_types',
  },
  attrs: {
    name: attr(),
    school: hasMany(),
  },
})

export default SchoolType
